import { openBlock, createElementBlock, renderSlot } from 'vue';

const _hoisted_1 = {
  class: "el-checkbox-group",
  role: "group",
  "aria-label": "checkbox-group"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1, [
    renderSlot(_ctx.$slots, "default")
  ]);
}

export { render };
//# sourceMappingURL=checkbox-group.vue_vue_type_template_id_9944d4d2_lang.mjs.map
